import { css } from '@emotion/react'
import styled from '@emotion/styled'

const Container = styled.div`
  ${({ theme }) => css`
    line-height: 1.75;
    white-space: normal;
    overflow-wrap: anywhere;
    color: ${theme.palette.text.primary};

    & > :first-of-type {
      margin-top: 0;
    }

    & > :last-child {
      margin-bottom: 0;
    }

    & p {
      margin: ${theme.spacing(1.5)}px 0;
    }

    & strong {
      font-weight: 600;
    }

    & h1,
    & h2,
    & h3,
    & h4,
    & h5,
    & h6 {
      font-weight: 600;
      line-height: 1.3;
      margin: ${theme.spacing(3)}px 0 ${theme.spacing(1)}px;
    }
 
    & ul,
    & ol {
      margin: ${theme.spacing(1.5)}px 0;
      padding-left: ${theme.spacing(3.5)}px;
    }

    & li {
      margin: ${theme.spacing(0.5)}px 0;
      padding-left: ${theme.spacing(0.5)}px;
    }

    & li::marker {
      color: ${theme.palette.text.secondary};
    }

    & li > p {
      margin: 0;
    }

    & li > ul,
    & li > ol {
      margin: ${theme.spacing(0.5)}px 0;
    }

    & a {
      color: ${theme.palette.primary.main};
      text-decoration: underline;
      text-underline-offset: 2px;
    }

    & blockquote {
      margin: ${theme.spacing(1.5)}px 0;
      padding-left: ${theme.spacing(2)}px;
      border-left: 3px solid ${theme.palette.divider};
      color: ${theme.palette.text.secondary};
    }

    & hr {
      margin: ${theme.spacing(3)}px 0;
      border: 0;
      border-top: 1px solid ${theme.palette.divider};
    }

    & code {
      padding: 2px ${theme.spacing(0.75)}px;
      border-radius: ${theme.shape.borderRadius}px;
      background-color: ${theme.palette.action.hover};
      font-family: Menlo, Consolas, 'Courier New', monospace;
      font-size: 0.875em;
    }

    & pre {
      margin: ${theme.spacing(1.5)}px 0;
      padding: ${theme.spacing(1.5)}px ${theme.spacing(2)}px;
      border-radius: ${theme.spacing(1)}px;
      background-color: ${theme.palette.action.hover};
      overflow-x: auto;
      white-space: pre;
    }

    & pre code {
      padding: 0;
      background: none;
      font-size: 0.85em;
    }

    & table {
      display: block;
      width: max-content;
      max-width: 100%;
      margin: ${theme.spacing(1.5)}px 0;
      border-collapse: collapse;
      overflow-x: auto;
    }

    & th,
    & td {
      padding: ${theme.spacing(0.75)}px ${theme.spacing(1.5)}px;
      border-bottom: 1px solid ${theme.palette.divider};
      text-align: left;
    }

    & th {
      font-weight: 600;
    }

    & .katex {
      font-size: 1.1em;
      color: ${theme.palette.text.primary};
    }

    & .katex-display {
      margin: ${theme.spacing(1.5)}px 0;
      overflow-x: auto;
      overflow-y: hidden;
    }
  `}
`

export { Container }
